<template>
    <div v-if="content" class="">
        <div class="card rounded-md p-2 flex justify-center items-center news-header">
            <div class="w-max-content" v-html="content"></div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

const TELEGRAM_START_PARAM_KEY = "start";
const TELEGRAM_START_PARAM_FALLBACK_VALUE = "start";
const TELEGRAM_BOT_LINK_REGEX = /https?:\/\/t\.me\/[A-Za-z0-9_]+(?:\?[^\s"'<>]*)?/gi;

export default {
    computed: {
        ...mapGetters(["notification", "referralLink"]),
        content() {
            let locale = this.$i18n.locale;

            let result = locale == "ru" ? this.notification.rus : this.notification.eng;

            return this.injectTelegramStartParam(result);
            // === "ru" ? "en" : "ru";
        }
    },
    methods: {
        injectTelegramStartParam(rawContent) {
            if (!rawContent || typeof rawContent !== "string") return rawContent;
            const startValue = this.referralLink || TELEGRAM_START_PARAM_FALLBACK_VALUE;
            const startParam = `${TELEGRAM_START_PARAM_KEY}=${encodeURIComponent(startValue)}`;

            return rawContent.replace(TELEGRAM_BOT_LINK_REGEX, (match) => {
                const usernameMatch = match.match(/^https?:\/\/t\.me\/([^/?#]+)/i);
                const username = usernameMatch?.[1] || "";

                // Only append ref param to bot links, not channels/chats.
                if (!/bot$/i.test(username)) return match;
                if (/[?&]start=/.test(match)) return match;

                return match.includes("?")
                    ? `${match}&${startParam}`
                    : `${match}?${startParam}`;
            });
        }
    },
    watch: {}
};
</script>

<style lang="scss" scoped>
@keyframes pulseShadow {
    0% {
        transform: scale(1);
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    }
    10% {
        transform: scale(1.02);
        box-shadow: 0 8px 15px rgba(0, 0, 0, 0.3);
    }
    20% {
        transform: scale(1);
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    }
    100% {
        transform: scale(1);
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    }
}

.news-header {
    animation: pulseShadow 10s ease-in-out infinite;
}
</style>
